import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyApprovalWorkflow({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166 146c-45.28-3.13-66.68 14.56-111 14.56-39.06 0-63.7-44.94-49-77.06C21.72 49.15 75.45 49.92 108 28c93.53-63 112.5 22 126 64s-23.22 57.1-68 54z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.98 98.4c25.02 22.1 67.8 18.5 117.52-2.42 34.31-14.45 79.08-19.78 111.81-13.22.87 3.23 1.76 6.34 2.69 9.24 13.5 42-23.22 57.1-68 54-24.16-1.67-41.53 2.59-59.2 6.93-15.45 3.78-31.13 7.63-51.8 7.63-33.28 0-56.1-32.64-53.02-62.16z"
        fill="#8F9DD6"
      />
      <rect x={89} y={16} width={51} height={17} rx={8.5} fill="#92A2E4" />
      <rect x={89} y={124} width={51} height={17} rx={8.5} fill="#92A3E7" />
      <rect
        x={42}
        y={54}
        width={67}
        height={18}
        rx={1}
        fill="#fff"
        filter="url(#pic-empty-approval-workflow_svg__a)"
      />
      <rect
        x={42}
        y={85}
        width={67}
        height={18}
        rx={1}
        fill="#fff"
        opacity={0.95}
        filter="url(#pic-empty-approval-workflow_svg__b)"
      />
      <rect
        x={121}
        y={54}
        width={67}
        height={18}
        rx={1}
        fill="#fff"
        filter="url(#pic-empty-approval-workflow_svg__c)"
      />
      <rect
        x={121}
        y={85}
        width={67}
        height={18}
        rx={1}
        fill="#fff"
        opacity={0.95}
        filter="url(#pic-empty-approval-workflow_svg__d)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.4 119v-5.1h39V104a.4.4 0 10-.8 0v9.1H76.4V104a.4.4 0 10-.8 0v9.9h39v5.1h-2.1l2.5 3.89 2.5-3.89h-2.1z"
        fill="#96A6E4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115 33.6c.22 0 .4.18.4.4v7.1h39V49h2.1l-2.5 3.89-2.5-3.89h2.1v-7.1H76.4V49h2.1L76 52.89 73.5 49h2.1v-7.9h39V34c0-.22.18-.4.4-.4zM76.4 73a.4.4 0 00-.8 0v7h-2.1l2.5 3.89L78.5 80h-2.1v-7zm78 0a.4.4 0 10-.8 0v7h-2.1l2.5 3.89 2.5-3.89h-2.1v-7z"
        fill="#A6B2E2"
      />
      <g filter="url(#pic-empty-approval-workflow_svg__e)" fillRule="evenodd" clipRule="evenodd">
        <path
          d="M219.88 123.95c-.03-.45-.4-.84-.92-.98l-6.52-1.72a23.21 23.21 0 00-1.8-4.35l3.4-5.82c.27-.47.25-1-.05-1.34a68.62 68.62 0 00-5.73-5.73c-.33-.3-.87-.32-1.34-.05l-5.82 3.4a23.25 23.25 0 00-4.35-1.8l-1.72-6.52c-.14-.53-.53-.9-.98-.92a69.17 69.17 0 00-8.1 0c-.45.03-.84.4-.98.92l-1.72 6.52a23.28 23.28 0 00-4.35 1.8l-5.82-3.4c-.47-.27-1-.25-1.34.05a68.62 68.62 0 00-5.73 5.73c-.3.33-.32.87-.05 1.34l3.4 5.82a23.28 23.28 0 00-1.8 4.35l-6.52 1.72c-.53.14-.9.53-.92.98a68.82 68.82 0 000 8.1c.03.45.4.84.92.98l6.52 1.72a23.25 23.25 0 001.8 4.35l-3.4 5.82c-.27.47-.25 1 .05 1.34a68.04 68.04 0 005.73 5.73c.33.3.87.32 1.34.05l5.82-3.4c1.38.74 2.83 1.35 4.35 1.8l1.72 6.52c.14.53.53.9.98.92a68.82 68.82 0 008.1 0c.45-.03.84-.4.98-.92l1.72-6.52a23.18 23.18 0 004.35-1.8l5.82 3.4c.47.27 1 .25 1.34-.05a68.04 68.04 0 005.73-5.73c.3-.33.32-.87.05-1.34l-3.4-5.82a23.18 23.18 0 001.8-4.35l6.52-1.72c.53-.14.9-.53.92-.98a68.82 68.82 0 000-8.1z"
          fill="#717074"
        />
        <path d="M190 141.93a13.93 13.93 0 110-27.86 13.93 13.93 0 010 27.86z" fill="#F9FAFA" />
        <path d="M190 119.43a8.57 8.57 0 100 17.14 8.57 8.57 0 000-17.14z" fill="#666" />
      </g>
      <defs>
        <filter
          id="pic-empty-approval-workflow_svg__a"
          x={39}
          y={52}
          width={73}
          height={24}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.14 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2545_2015" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2545_2015" result="shape" />
        </filter>
        <filter
          id="pic-empty-approval-workflow_svg__b"
          x={39}
          y={83}
          width={73}
          height={24}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.14 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2545_2015" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2545_2015" result="shape" />
        </filter>
        <filter
          id="pic-empty-approval-workflow_svg__c"
          x={118}
          y={52}
          width={73}
          height={24}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.14 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2545_2015" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2545_2015" result="shape" />
        </filter>
        <filter
          id="pic-empty-approval-workflow_svg__d"
          x={118}
          y={83}
          width={73}
          height={24}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.14 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2545_2015" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2545_2015" result="shape" />
        </filter>
        <filter
          id="pic-empty-approval-workflow_svg__e"
          x={156}
          y={96}
          width={68}
          height={68}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2545_2015" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2545_2015" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyApprovalWorkflow.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyApprovalWorkflow.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyApprovalWorkflow svgRef={ref} {...props} />
));
export default ForwardRef;
